module.exports = __webpack_public_path__ + "static/media/ic_selectArrowDownOrangeBold.d2b104a3.svg";